import { Router } from '@angular/router';
import { FrontendLoggerService } from 'src/app/services/frontend-logger.service';
import { DocumentGroup, GroupedDocument } from './document-details.models';

export interface DocumentContextMenuPlacement {
  document: GroupedDocument;
  x: number;
  y: number;
}

export class DocumentContextMenuCoordinator {
  constructor(
    private readonly router: Router,
    private readonly logger: FrontendLoggerService
  ) {}

  locate(event: MouseEvent, groups: DocumentGroup[], confirmationVisible: boolean): DocumentContextMenuPlacement | null {
    const target = event.target as HTMLElement;
    const host = document.querySelector('app-document-details');
    if (host && !host.contains(target)) {
      return null;
    }
    const row = target.closest('.details-doc-row') as HTMLElement | null;
    const groupIndex = this.indexFrom(row, 'data-group-idx');
    const documentIndex = this.indexFrom(row, 'data-doc-idx');
    if (!row || groupIndex === null || documentIndex === null) {
      return null;
    }
    const selected = groups[groupIndex]?.documents?.[documentIndex];
    if (!selected) {
      return null;
    }
    event.preventDefault();
    return {
      document: selected,
      x: Math.min(event.clientX, globalThis.innerWidth - 258),
      y: Math.min(event.clientY, globalThis.innerHeight - (confirmationVisible ? 148 : 88))
    };
  }

  confirm(
    selected: GroupedDocument,
    confirmed: boolean
  ): void {
    try {
      const safeName = String(selected.original_filename || '').replace(/\|/g, ' ');
      localStorage.setItem('limitChatDocId', `${String(selected.id)}|${safeName}`);
    } catch (error) {
      this.logger.warn('[document-details] could not write to localStorage: ' + String(error));
    }
    if (confirmed) {
      this.router.navigate(['/chat']);
    } else {
      localStorage.removeItem('limitChatDocId');
    }
  }

  private indexFrom(row: HTMLElement | null, attribute: string): number | null {
    const rawValue = row?.getAttribute(attribute);
    if (rawValue == null) {
      return null;
    }
    const value = Number.parseInt(rawValue, 10);
    return Number.isNaN(value) ? null : value;
  }
}
